<!-- to be removed later:not in use -->


<div class="relative h-screen w-full overflow-hidden text-white">
  <!-- Background Carousel -->
  <div
    class="absolute   background-img    duration-1000"
    *ngFor="let img of images; let i = index"
    [ngClass]="{ 'opacity-100': currentIndex === i, 'opacity-0': currentIndex !== i }"
  >
    <img [src]="img" class="object-cover w-full h-full brightness-110" />
  </div>
 
  <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-center justify-center px-4">
   
    <div class="flex flex-col items-center justify-center text-center w-full max-w-xxl space-y-6">

      <img src="assets/shared/logo-white.svg" alt="Collegiate Mobile Logo" title="Collegiate Mobile Logo" class="h-20 md:h-18 w-auto">

	<!-- Heading -->
	<div class="text-4xl sm:text-5xl md:text-7xl  font-bold italic uppercase  sm:text-center"
	style="font-family: 'Alumni Sans SC'; display: swap; ">
		SUPPORT YOUR SCHOOL <br>
		JUST BY PAYING YOUR <br> PHONE BILL
	</div>

      <!-- Subheading -->
      <p
        class="text-base sm:text-lg md:text-xl font-bold italic"
        style="font-family: 'Poppins'; display:swap"
      >
        A direct portion of your bill goes to your school <br>
        when you switch to Collegiate Mobile.
      </p>

      <!-- Form validation +Email + Button -->
      <div class="flex flex-col sm:flex-row items-center justify-center w-full sm:w-auto gap-2 px-4 sm:px-0">
		<form #emailForm="ngForm" (ngSubmit)="callvisitoranalytics()" >
			<input type="email" name="email" (ngModelChange)="resetSuccessMessage()"
					required
					email
					#emailField="ngModel"
					placeholder="Enter your email"
						class="  text-black p-3 rounded focus:outline-none px-4 py-2 rounded-md text-black w-full sm:w-auto"
						[(ngModel)] ="email">
					<button class="bg-indigo-500 hover:bg-indigo-600 px-6 py-2 rounded-md text-white font-semibold w-full sm:w-auto mt-2">Stay Updated</button>

					<div *ngIf="emailField.touched && emailField.invalid" class="text-white text-md mt-1">
					<div *ngIf="emailField.errors?.['email']">Please enter a valid email address.</div>
			</div>

			<div class="text-white text-md mt-4" *ngIf="showSuccessMessage">
				Thanks for registering, our team will get back to you.
			</div>
        </form>
      </div>

      <div class="text-xs sm:text-sm font-semibold tracking-wider bg-black bg-opacity-70 px-4 py-1 rounded-full">COMING SOON</div>
    </div>
  </div>
</div>
